export default __webpack_public_path__ + "static/column-with-negative-values-f8ca4a77986e50228a50185246cb7391.png";